(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-name-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    console.log('🚀 Customer Name Modal initializing...');

    const modal = document.querySelector('#CustomerNameModal');
    if (!modal) {
      console.log('❌ Customer Name Modal element not found');
      return;
    }

    console.log('✅ Modal found:', modal);

    // Debug information
    console.log('Customer Name Modal Debug:', {
      hasBlankName: modal.dataset.hasBlankName,
      customerId: modal.dataset.customerId,
      mandatory: true,
      element: modal,
    });

    // Make modal undismissable by overriding dialog component methods
    const originalCloseDialog = modal.closeDialog;
    modal.closeDialog = () => {
      console.log('🚫 Close dialog blocked - mandatory information required');
      // Prevent closing - this is mandatory information
      return;
    };

    // Also override any click or keydown handlers that might try to close
    modal.addEventListener(
      'click',
      (event) => {
        // Prevent outside clicks from bubbling to dialog component
        event.stopPropagation();
      },
      true,
    );

    modal.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') {
          console.log('🚫 Escape key blocked - mandatory information required');
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true,
    );

    // Check if modal should auto-show (mandatory for blank names)
    const hasBlankName = modal.dataset.hasBlankName === 'true';

    console.log('Auto-show conditions:', { hasBlankName, mandatory: true });

    if (hasBlankName) {
      console.log('Showing customer name modal...');
      // Small delay to ensure page is ready
      setTimeout(() => {
        // Hide any messages when modal opens
        hideMessages();
        modal.showDialog();
      }, 1000);
    } else {
      console.log('Not showing modal:', { hasBlankName });
    }

    // Initialize form handling
    const form = modal.querySelector('#customerNameForm');

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    async function handleSubmit(event) {
      event.preventDefault();

      const formData = new FormData(event.target);
      const firstName = formData.get('firstName');
      const lastName = formData.get('lastName');

      console.log('Form submitted:', { firstName, lastName });

      // Hide previous messages
      hideMessages();

      // Validate required fields
      if (!firstName || !lastName) {
        showError(modal.dataset.errorRequired);
        return;
      }

      // Set loading state
      setLoadingState(true);

      try {
        // Call DigitalOcean Function to update customer name
        const response = await fetch(
          'https://faas-tor1-70ca848e.doserverless.co/api/v1/web/fn-5f8691a7-ed75-42aa-a79a-44441be3c4e7/update-customer/update-customer-name',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Shop-Domain': modal.dataset.shopDomain,
              'X-Customer-ID': modal.dataset.customerId,
            },
            body: JSON.stringify({
              customerId: modal.dataset.customerId,
              firstName: firstName,
              lastName: lastName,
            }),
          },
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          console.error('Server response:', errorData);
          throw new Error(`HTTP ${response.status}: ${errorData.error || response.statusText}`);
        }

        const result = await response.json();
        console.log('Customer name update successful:', result);

        // Show success message
        showSuccess();

        // Restore original close function and close modal after success
        modal.closeDialog = originalCloseDialog;
        setTimeout(() => {
          modal.closeDialog();
        }, 3000);
      } catch (error) {
        console.error('Error updating customer name:', error);
        showError(error.message || modal.dataset.errorGeneral);
      } finally {
        setLoadingState(false);
      }
    }

    // Skip functionality removed - this is mandatory information

    function showError(message) {
      const errorElement = modal.querySelector('#customerNameError');
      const errorTextElement = modal.querySelector('.customer-name-modal__error-text');

      // Hide any existing messages first
      hideMessages();

      if (errorElement && errorTextElement) {
        errorTextElement.textContent = message;
        errorElement.hidden = false;
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showSuccess() {
      const successElement = modal.querySelector('#customerNameSuccess');
      const errorElement = modal.querySelector('#customerNameError');

      // Hide error and show success
      hideMessages(); // Hide any existing messages first

      if (successElement) {
        successElement.hidden = false;
        successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function hideMessages() {
      const errorElement = modal.querySelector('#customerNameError');
      const successElement = modal.querySelector('#customerNameSuccess');

      if (errorElement) errorElement.hidden = true;
      if (successElement) successElement.hidden = true;
    }

    function setLoadingState(loading) {
      const submitButton = modal.querySelector('#customerNameSubmit');

      modal.classList.toggle('customer-name-modal--loading', loading);

      if (submitButton) {
        submitButton.disabled = loading;
        submitButton.textContent = loading ? modal.dataset.savingText : modal.dataset.saveText;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-form-simple"] && !Shopify.designMode) return;
  try {
    class LiveForm {
    constructor(formElement) {
      this.form = formElement;
      this.formId = formElement.id;
      this.errorElement = document.getElementById(`${this.formId}-error`);
      this.successElement = document.getElementById(`${this.formId}-success`);
      this.rulesModal = document.getElementById(`${this.formId}-rules-modal`);
      this.rulesTrigger = this.form.querySelector('[data-rules-trigger]');
      this.rulesClose = this.form.querySelector('[data-rules-close]');

      // Store original button text for restoration
      const submitButton = this.form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.setAttribute('data-original-text', submitButton.textContent);
      }

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      if (this.rulesTrigger) {
        this.rulesTrigger.addEventListener('click', this.showRules.bind(this));
      }

      if (this.rulesClose) {
        this.rulesClose.addEventListener('click', this.hideRules.bind(this));
      }

      // Close modal on outside click
      if (this.rulesModal) {
        this.rulesModal.addEventListener('click', (e) => {
          if (e.target === this.rulesModal) {
            this.hideRules();
          }
        });
      }

      // Close modal on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.rulesModal && this.rulesModal.style.display !== 'none') {
          this.hideRules();
        }
      });
    }

    async handleSubmit(event) {
      event.preventDefault();

      const formData = new FormData(this.form);
      const submitButton = this.form.querySelector('button[type="submit"]');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = this.form.dataset.submittingText;
      }

      try {
        // Prepare data in the same format as contest form
        const data = {
          firstName: formData.get('firstName'),
          lastName: formData.get('lastName'),
          email: formData.get('email'),
          tags: formData.get('customer_tags'),
          acceptsMarketing: true,
          locale: document.documentElement.lang || 'en',
          language: navigator.language || 'en'
        };

        // Debug: Log what we're sending (matching contest form debug approach)
        console.log('🔧 DEBUG: Sending data:', data);
        console.log('🔧 DEBUG: Shop domain:', window.location.hostname);
        console.log('🔧 DEBUG: Current locale:', document.documentElement.lang || 'en');

        // Submit to the exact same DigitalOcean function endpoint as contest form
        const response = await fetch(
          'https://faas-tor1-70ca848e.doserverless.co/api/v1/web/fn-5f8691a7-ed75-42aa-a79a-44441be3c4e7/update-customer/update-customer-contest-form?t=' +
            Date.now(),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Shop-Domain': window.location.hostname,
            },
            body: JSON.stringify(data),
          }
        );

        console.log('🔧 DEBUG: Response status:', response.status);
        console.log('🔧 DEBUG: Response headers:', response.headers);

        const result = await response.json();
        console.log('🔧 DEBUG: Response data:', result);

        if (response.ok && result.success) {
          // Hide form and show success message
          this.form.style.display = 'none';
          this.showSuccessMessage();
        } else {
          this.showErrorMessage(result.message || this.form.dataset.errorText);
        }
      } catch (error) {
        console.error('Form submission error:', error);
        this.showErrorMessage(this.form.dataset.networkErrorText);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.getAttribute('data-original-text') || this.form.dataset.registerText;
        }
      }
    }

    showSuccessMessage() {
      if (this.successElement) {
        this.successElement.style.display = 'flex';
        this.successElement.focus();
      }
    }

    showErrorMessage(message) {
      if (this.errorElement) {
        const messageElement = this.errorElement.querySelector('.live-form__error-message');
        if (messageElement) {
          messageElement.textContent = message;
        }
        this.errorElement.style.display = 'flex';
        this.errorElement.focus();
      }
    }

    showRules() {
      if (this.rulesModal) {
        this.rulesModal.style.display = 'flex';
        this.rulesModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }

    hideRules() {
      if (this.rulesModal) {
        this.rulesModal.style.display = 'none';
        this.rulesModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  }

  // Initialize all live forms on the page
  document.addEventListener('DOMContentLoaded', () => {
    const liveForms = document.querySelectorAll('[data-live-form]');
    liveForms.forEach(form => new LiveForm(form));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lv-certificate-generator"] && !Shopify.designMode) return;
  try {
    (function () {
    // Read debug data (kept for console visibility)
    try {
      const debugData = document.getElementById('certificate-debug-data');
      if (debugData) {
        //console.log('Certificate debug data:', JSON.parse(debugData.textContent));
      }
    } catch (e) {
      //console.error('Error parsing certificate debug data:', e);
    }

    class CertificateGenerator {
      constructor() {
        // Bind the method once to maintain reference for removeEventListener
        this.handleGenerateCertificate = this.generateCertificate.bind(this);
        this.initialize();
      }

      initialize() {
        this.buttons = document.querySelectorAll('[data-certificate-generator]');
        if (!this.buttons.length) return;

        this.buttons.forEach((button, i) => {
          // Remove existing listeners to prevent duplicates
          button.removeEventListener('click', this.handleGenerateCertificate);

          //console.log(`Certificate button ${i}:`, button.dataset);
          button.addEventListener('click', this.handleGenerateCertificate);

          // Mark button as initialized to avoid duplicate processing
          button.dataset.certificateInitialized = 'true';
        });
      }

      // Method to reinitialize from external code
      reinitialize() {
        //console.log('🎓 Certificate generator reinitializing...');
        this.initialize();
      }

      // 🆕 NEW: Plunk tracking function for certificate events
      async trackCertificateEvent(formationTitle, certificateUrl) {
        try {
          // Get customer data from the certificate generator container
          const container = document.querySelector('.lv-certificate-generator');
          const customerEmail = container?.dataset.customerEmail || '';
          const customerFirstName = container?.dataset.customerFirstName || '';

          const trackingData = {
            event: 'certificate-added',
            email: customerEmail,
            subscribed: true,
            data: {
              customerFirstName: customerFirstName,
              formationTitle: formationTitle,
              certificateUrl: certificateUrl,
            },
          };

          console.log('📊 Tracking certificate event (manual generation):', trackingData);

          const response = await fetch('https://api.useplunk.com/v1/track', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer pk_34c6d24c671d023b347754123d85c9bf51b7ab41d3453f93',
            },
            body: JSON.stringify(trackingData),
          });

          if (response.ok) {
            console.log('✅ Certificate event tracked successfully (manual)');
          } else {
            console.warn('⚠️ Failed to track certificate event (manual):', response.status, response.statusText);
          }
        } catch (error) {
          console.error('❌ Error tracking certificate event (manual):', error);
          // Don't throw - tracking failure shouldn't break certificate generation
        }
      }

      async generateCertificate(event) {
        event.preventDefault();
        const button = event.currentTarget;

        // UI state → loading
        const originalText = button.textContent;
        button.disabled = true;
        button.classList.add('loading');
        button.textContent = button.dataset.textGenerating;

        try {
          // Collect all data attributes
          const dataset = button.dataset;

          // Build certificate data object
          const certificateData = {
            // Required fields
            name: dataset.name,
            course: dataset.course,
            date: dataset.date,
            logo: dataset.logo,

            // Optional fields
            instructor: dataset.instructor !== 'N/A' ? dataset.instructor : '',

            // Customizable text elements
            mainTitle: dataset.mainTitle,
            subtitle: dataset.subtitle,
            achievementText: dataset.achievementText,
            datePrefix: dataset.datePrefix,
            instructorTitle: dataset.instructorTitle,
            certificateIdPrefix: dataset.certificateIdPrefix,
            certificateId: dataset.certificateId,
            organizationName: dataset.organizationName,
            organizationTagline: dataset.organizationTagline,
            signatureImageUrl: dataset.signatureImageUrl,
            backgroundImageUrl: dataset.backgroundImageUrl,
            legalText: dataset.legalText,

            // Branch details for the new third column
            branchLogoUrl: dataset.branchLogoUrl,
            branchNumber: dataset.branchNumber,

            // Additional fields
            additionalFields: {},
          };

          // Add any other custom fields you want to include
          // Example: Grade, Credits, etc.
          // if (dataset.grade) {
          //   certificateData.additionalFields.Grade = dataset.grade;
          // }

          // Call the certificate function
          await this.callCertificateFunction(
            button,
            certificateData,
            dataset.shopDomain,
            dataset.customerId,
            originalText,
          );
        } catch (error) {
          console.error('Certificate generation failed:', error);
          button.classList.remove('loading');
          button.textContent = button.dataset.textError;
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 3000);
        }
      }

      async callCertificateFunction(button, requestData, shopDomain, customerId, originalText) {
        const functionUrl =
          'https://faas-tor1-70ca848e.doserverless.co/api/v1/web/' +
          'fn-5f8691a7-ed75-42aa-a79a-44441be3c4e7/update-customer/generate-certificate';

        //console.log('POST →', functionUrl, requestData);

        const response = await fetch(functionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Shop-Domain': shopDomain,
            'X-Customer-ID': customerId,
          },
          body: JSON.stringify(requestData),
        });

        const text = await response.text();
        //console.log('Server response:', response.status, text);

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const result = JSON.parse(text);
        if (!result.success) throw new Error(result.error || 'Certificate generation failed');

        // Handle the response based on what's returned
        if (result.pdfBase64) {
          // Always use base64 for immediate download
          //console.log('Using base64 for immediate download');

          const byteCharacters = atob(result.pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          // Create an object URL and trigger download
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Generate filename
          const safeCourseTitle = requestData.course.replace(/[^a-z0-9]/gi, '-').toLowerCase();
          const timestamp = new Date().toISOString().split('T')[0];
          link.download = `${safeCourseTitle}-certificate-${timestamp}.pdf`;

          document.body.appendChild(link);
          link.click();

          // Clean up
          setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          }, 100);

          // If we have a certificate URL, update the metafield
          if (result.certificateUrl && window.LVFormationsProgress) {
            //console.log('Updating metafield with certificate URL:', result.certificateUrl);

            // Get formation ID from data attributes
            const formationId = button.dataset.certificateId?.split('-')[1];
            const formationTitle = requestData.course;

            if (formationId) {
              // Update formation progress with certificate URL using the correct method name
              // LVFormationsProgress.update(formationId, formationTitle, lessonNumber, extraData)
              const currentLesson = 1; // Default lesson number for certificate generation

              await window.LVFormationsProgress.update(formationId, formationTitle, currentLesson, {
                certificate_url: result.certificateUrl,
                certificate_generated_at: new Date().toISOString(),
                certificate_filename: result.filename,
              });

              // 🆕 NEW: Track certificate generation event
              await this.trackCertificateEvent(formationTitle, result.certificateUrl);
            }
          }
        } else if (result.fileUrl) {
          // Fallback: Certificate uploaded to Shopify - download from URL
          //console.log('Certificate uploaded to Shopify:', result.fileUrl);

          // Open in new tab/window - this will trigger browser download
          window.open(result.fileUrl, '_blank');

          // 🆕 NEW: Track certificate generation event for fallback case
          const formationTitle = requestData.course;
          await this.trackCertificateEvent(formationTitle, result.fileUrl);
        } else {
          throw new Error('No certificate data received');
        }

        // Success UI
        button.classList.remove('loading');
        button.textContent = button.dataset.textSuccess;
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 3000);
      }
    }

    // Initialize certificate generator and make it globally accessible for reinitializing
    if (!window.LVCertificateGenerator) {
      window.LVCertificateGenerator = new CertificateGenerator();
    } else {
      // If it already exists, just reinitialize
      window.LVCertificateGenerator.reinitialize();
    }

    // Watch for section replacements and reinitialize certificate generator
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              (node.classList.contains('formations-lms') ||
                (node.querySelector && node.querySelector('.formations-lms')))
            ) {
              // Section was replaced, reinitialize certificate generator
              //console.log('🎓 Section replaced, reinitializing certificate generator...');
              setTimeout(() => {
                if (window.LVCertificateGenerator) {
                  window.LVCertificateGenerator.reinitialize();
                }
              }, 100);
            }
          });
        }
      });
    });

    // Start observing for section replacements
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
